module.exports = __webpack_public_path__ + "media/images/landing/bg/case-nestle/intro-ebfc086c26418c4fe0e5f789707e4e77.jpg";